/* eslint-disable no-param-reassign,consistent-return */
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import {
  getRejectedTrafficsDetailSearch,
  getRejectedTrafficsRoute,
  getTrafficSliceableSearchRoute,
} from "../../lib/routes/rejected-traffic";
import rtkRequestStatusCodes from "../../lib/const/rtkRequestStatusCodes";
import Message from "../../components/Message/Message";
import { updateTariffication } from "../../lib/routes/pre-processor";

const initialState = {
  subscriberId: null,
  statusId: null,
  rejectedTraffics: null,
  rejectedTrafficsLoading: rtkRequestStatusCodes.idle,
  rejectedTrafficsDetail: [],
  rejectedTrafficsDetailLoading: rtkRequestStatusCodes.idle,
  tariffication: {},
  tarifficationLoading: rtkRequestStatusCodes.idle,
  fetchRejectedTrafficDetailSearchContentLoading: rtkRequestStatusCodes.idle,
  fetchRejectedTrafficDetailSearchContent: [],
};

const fetchRejectedTraffics = createAsyncThunk(
  "rejected/fetchRejectedTraffics",
  async (searchParams) => {
    try {
      const url = getRejectedTrafficsRoute(searchParams);
      const { data } = await axios(url);
      return data.map((item) => {
        item.statusName = "";
        return item;
      });
    } catch (e) {
      Message("Ошибка загрузки данных. Попробуйте позже", e);
    }
  }
);

const fetchRejectedTrafficDetail = createAsyncThunk(
  "rejected/fetchSearchRejectedTraffic",
  async (searchParams) => {
    try {
      // const url = [
      //   getRejectedTrafficsDetail(),
      //   "/service-usages",
      //   "/pageable-search",
      //   queryString,
      // ].join("")getRejectedTrafficsDetail
      const url = getRejectedTrafficsDetailSearch(searchParams);
      const { data } = await axios(url);
      return data;
    } catch (e) {
      Message("Ошибка загрузки данных. Попробуйте позже", e);
    }
  }
);

const fetchRejectedTrafficDetailSearch = createAsyncThunk(
  "rejected/fetchRejectedTrafficDetailSearch",
  async (searchParams) => {
    try {
      const url = getTrafficSliceableSearchRoute(searchParams);
      const { data } = await axios.get(url);
      return data;
    } catch (e) {
      Message("Ошибка загрузки данных. Попробуйте позже", e);
    }
  }
);

const handleReTariffication = createAsyncThunk("rejected/reTariff", async (values) => {
  try {
    const response = axios.post(updateTariffication(), values);
    const { data } = await response;
    const { status } = await response;
    Message("Дотарификация прошла", status);
    return data;
  } catch (e) {
    Message("Ошибка дотарификации", e);
  }
});

const slice = createSlice({
  name: "rejected",
  initialState,
  reducers: {
    resetRejectedTrafficDetailSearch: {
      reducer: (state) => {
        state.fetchRejectedTrafficDetailSearchContent = [];
        state.fetchRejectedTrafficDetailSearchContentLoading = rtkRequestStatusCodes.idle;
      },
    },
  },
  extraReducers: {
    [fetchRejectedTraffics.fulfilled]: (state, { payload }) => {
      state.rejectedTraffics = payload;
      state.rejectedTrafficsLoading = rtkRequestStatusCodes.fulfilled;
    },
    [fetchRejectedTraffics.pending]: (state) => {
      state.rejectedTrafficsLoading = rtkRequestStatusCodes.pending;
    },
    [fetchRejectedTraffics.rejected]: (state) => {
      state.rejectedTrafficsLoading = rtkRequestStatusCodes.rejected;
    },
    [fetchRejectedTrafficDetail.fulfilled]: (state, { payload }) => {
      state.rejectedTrafficsDetail = payload;
      state.rejectedTrafficsDetailLoading = rtkRequestStatusCodes.fulfilled;
    },
    [fetchRejectedTrafficDetail.pending]: (state) => {
      state.rejectedTrafficsDetailLoading = rtkRequestStatusCodes.pending;
    },
    [fetchRejectedTrafficDetail.rejected]: (state) => {
      state.rejectedTrafficsDetailLoading = rtkRequestStatusCodes.rejected;
    },
    [fetchRejectedTrafficDetailSearch.fulfilled]: (state, { payload }) => {
      state.fetchRejectedTrafficDetailSearchContent = payload;
      state.fetchRejectedTrafficDetailSearchContentLoading = rtkRequestStatusCodes.fulfilled;
    },
    [fetchRejectedTrafficDetailSearch.pending]: (state) => {
      state.fetchRejectedTrafficDetailSearchContentLoading = rtkRequestStatusCodes.pending;
    },
    [fetchRejectedTrafficDetailSearch.rejected]: (state) => {
      state.fetchRejectedTrafficDetailSearchContentLoading = rtkRequestStatusCodes.rejected;
    },
    [handleReTariffication.pending]: (state) => {
      state.tarifficationLoading = rtkRequestStatusCodes.pending;
    },
    [handleReTariffication.fulfilled]: (state, action) => {
      state.tariffication = action.payload?.data;
      state.tarifficationLoading = rtkRequestStatusCodes.fulfilled;
    },
    [handleReTariffication.rejected]: (state) => {
      state.tarifficationLoading = rtkRequestStatusCodes.rejected;
    },
  },
});

const { actions, reducer } = slice;
const { resetRejectedTrafficDetailSearch } = actions;

export {
  actions,
  fetchRejectedTraffics,
  fetchRejectedTrafficDetail,
  fetchRejectedTrafficDetailSearch,
  handleReTariffication,
  resetRejectedTrafficDetailSearch,
};
export default reducer;
